import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const rapidboardReportRoute: InvariantJiraRoute = {
	name: 'rapidboard-report',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView',
};
